<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useAuthStore } from '~/stores/auth.store';
import { InformationCircleIcon } from '@heroicons/vue/24/outline';
import { useSiteStore } from '~/stores/site.store';

const { $t } = useNuxtApp();
const auth = useAuthStore();
const site = useSiteStore();

function verifyAccount() {
  site.deactivateModal();
  auth.setAccountModalPage('document-verification');
}
</script>

<template>
  <div class="flex flex-col flex-wrap justify-center align-content-start mx-3">
    <div class="flex justify-center mt-3 w-full mb-1">
      <InformationCircleIcon class="text-gold-500 w-16 h-16" />
    </div>
    <p class="text-base-priority font-bold mb-3">
      {{ $t('jpc-partially-complete-profile') }}
    </p>
    <p class="text-base-priority mb-3">
      <strong>{{ $t('id-verification') }}:&nbsp;</strong>
      <span class="text-gold-500">
        {{ $t('unsuccessful') }}
      </span>
    </p>
  </div>
  <div class="w-full bg-base flex justify-center">
    <Button
      element-name="verify-account"
      @click="verifyAccount()"
      class="w-full m-3 justify-center"
    >
      {{ $t('verify-account') }}
    </Button>
  </div>
</template>
